// redux/store.js

import { configureStore } from "@reduxjs/toolkit";

import defaultReducer from "./slice/DefaultSlice";
import userReducer from "./slice/UserSlice";
import productReducer from "./slice/ProductSlice";
import uploadReducer from "./slice/UploadSlice";

export const store = configureStore({
  reducer: {
    default: defaultReducer,
    user: userReducer,
    product: productReducer,
    upload: uploadReducer,
  },
});
